import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import hero1 from "../../assets/hero1.png";
import hero2 from "../../assets/hero2.png";
import hero3 from "../../assets/hero3.png";
import hero4 from "../../assets/hero4.png";
import hero5 from "../../assets/hero5.png";

const Hero = () => {
  const navigate = useNavigate();
  const [activeBanner, setActiveBanner] = useState(0);

  const banners = [
    {
      image: hero1,
      type: "intro",
      title: "Patch Designers - Your Premier Custom Patch Creators in the USA",
      subtitle:
        "Trusted Patch Designers & Custom Patch Designers USA for Every Brand, Team, and Style",
      text: "When you want professional, eye-catching patches, you need more than a generic badge maker - you need expert Patch Designers who understand quality, detail, and purpose.",
      text2:
        "Whether you're a business, club, team, or individual, our team helps you design your own patch online with ease. In a crowded market, we stand out as custom patch designers USA who deliver creative solutions, fast turnaround, and nationwide service.",
      text3:
        "Stop settling for ordinary. Select caring professionals who are concerned about each stitch and each detail.",
      button: "Customize Patches",
    },
    {
      image: hero2,
      title: "Premium Patch Designer Services",
      type: "perks",
      perks: [
        { icon: "truck", normal: "Fast", bold: "Shipping" },
        { icon: "clock", normal: "Quick", bold: "Turnaround" },
        { icon: "quote", normal: "Easy", bold: "Ordering" },
        { icon: "shape", normal: "Custom", bold: "Styles" },
        { icon: "sample", normal: "Digital", bold: "Mockup" },
        { icon: "quality", normal: "Premium", bold: "Quality" },
      ],
    },
    {
      image: hero3,
      title: "Bring Your Creativity To Life",
      text: "Our business is to bring your creativity to life in form of stylish, durable and professional-looking patches to make your hats unique.",
      button: "Explore Products",
    },
    {
      image: hero4,
      title: "Perfect For Teams, Brands & Fashion",
      text: "Whether it's for a sports team, brand promotion, or personal fashion statement, our Patch Designer delivers quality and detail every time.",
      button: "Customize Patches",
    },
    {
      image: hero5,
      title: "Professional Patches For Your Style",
      text: "Get durable, premium-quality patches designed to make your hats, apparel, and brand stand out with a professional look.",
      button: "Explore Products",
    },
  ];

  const nextBanner = () => {
    setActiveBanner((prev) => (prev + 1) % banners.length);
  };

  const prevBanner = () => {
    setActiveBanner((prev) => (prev - 1 + banners.length) % banners.length);
  };

  const renderPerkIcon = (type) => {
    const common =
      "h-[34px] w-[34px] shrink-0 text-[#f97316] sm:h-[42px] sm:w-[42px] lg:h-[50px] lg:w-[50px]";

    if (type === "truck") {
      return (
        <svg className={common} viewBox="0 0 64 64" fill="none">
          <path d="M8 18h30v28H8V18Z" stroke="currentColor" strokeWidth="5" />
          <path
            d="M38 28h10l8 9v9H38V28Z"
            stroke="currentColor"
            strokeWidth="5"
          />
          <path
            d="M16 50a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM48 50a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
            stroke="currentColor"
            strokeWidth="5"
          />
          <path d="M13 26h14M13 34h10" stroke="currentColor" strokeWidth="5" />
        </svg>
      );
    }

    if (type === "clock") {
      return (
        <svg className={common} viewBox="0 0 64 64" fill="none">
          <path
            d="M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
          />
          <path
            d="M32 16v18l12-9"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 10v14h14"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    if (type === "quote") {
      return (
        <svg className={common} viewBox="0 0 64 64" fill="none">
          <path d="M14 10h34v44H14V10Z" stroke="currentColor" strokeWidth="5" />
          <path
            d="M22 10v12l5-4 5 4V10"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinejoin="round"
          />
          <path
            d="M36 37l5 5 10-14"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    }

    if (type === "shape") {
      return (
        <svg className={common} viewBox="0 0 64 64" fill="none">
          <path
            d="M8 8h20v20H8V8ZM36 8h20v20H36V8ZM8 36h20v20H8V36ZM36 36h20v20H36V36Z"
            stroke="currentColor"
            strokeWidth="5"
          />
          <path
            d="M14 18h8M46 14v12M42 20h12M16 46h8M44 44l8 8M52 44l-8 8"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </svg>
      );
    }

    if (type === "sample") {
      return (
        <svg className={common} viewBox="0 0 64 64" fill="none">
          <path
            d="M32 8 58 54H6L32 8Z"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinejoin="round"
          />
          <path
            d="M32 23v14M32 45h.1"
            stroke="currentColor"
            strokeWidth="5"
            strokeLinecap="round"
          />
        </svg>
      );
    }

    return (
      <svg className={common} viewBox="0 0 64 64" fill="none">
        <path
          d="M32 5 38 13l10-2 2 10 9 5-5 9 5 9-9 5-2 10-10-2-6 8-6-8-10 2-2-10-9-5 5-9-5-9 9-5 2-10 10 2 6-8Z"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        <path
          d="m32 20 4 9 10 1-7 7 2 10-9-5-9 5 2-10-7-7 10-1 4-9Z"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const banner = banners[activeBanner];

  return (
    <>
      <style>
        {`
          @keyframes heroFade {
            0% {
              opacity: 0.65;
              transform: scale(1.01);
            }
            100% {
              opacity: 1;
              transform: scale(1);
            }
          }
        `}
      </style>

      <div className="relative h-[620px] w-full overflow-hidden sm:h-[590px] md:h-[560px] lg:h-[600px] xl:h-[620px]">
        <div
          key={activeBanner}
          className="absolute inset-0 flex h-full w-full animate-[heroFade_500ms_ease-in-out] items-center bg-cover bg-center bg-no-repeat px-4 py-6 sm:px-8 md:px-14 lg:px-[90px] xl:px-[110px]"
          style={{
            backgroundImage: `linear-gradient(90deg, rgba(10,35,54,0.9), rgba(31,44,76,0.76), rgba(10,35,54,0.38)), url('${banner.image}')`,
          }}
        >
          <div className="mx-auto w-full max-w-[1180px] select-none rounded-[22px] border border-white/15 bg-[rgba(10,35,54,0.84)] px-5 py-6 shadow-[0_22px_60px_rgba(0,0,0,0.30)] backdrop-blur-[2px] sm:px-7 sm:py-7 lg:px-9 lg:py-8">
            {banner.type === "perks" ? (
              <div className="w-full">
               

                <h1 className="mb-6 font-['Source_Sans_Pro'] text-[26px] font-extrabold leading-tight text-[#f97316] sm:text-[34px] lg:mb-8 lg:text-[42px]">
                  {banner.title}
                </h1>

                <div className="grid grid-cols-1 gap-x-10 gap-y-4 sm:grid-cols-2 lg:gap-x-16 lg:gap-y-6">
                  {banner.perks.map((perk, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-4 lg:gap-5"
                    >
                      {renderPerkIcon(perk.icon)}

                      <p className="m-0 font-['Source_Sans_Pro'] text-[18px] font-normal leading-tight text-white sm:text-[22px] lg:text-[25px]">
                        {perk.normal}{" "}
                        <strong className="font-black text-white">
                          {perk.bold}
                        </strong>
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            ) : banner.type === "intro" ? (
              <div className="w-full max-w-[1050px]">
               

                <h1 className="m-0 block w-full font-['Source_Sans_Pro'] text-[24px] font-extrabold leading-[1.18] text-[#f97316] sm:text-[34px] lg:text-[46px] xl:text-[50px]">
                  {banner.title}
                </h1>

                <h2 className="mt-3 max-w-[980px] font-['Source_Sans_Pro'] text-[16px] font-bold leading-[24px] text-white sm:text-[20px] sm:leading-[28px] lg:text-[24px] lg:leading-[32px]">
                  {banner.subtitle}
                </h2>

                <div className="mt-4 space-y-3">
                  <p className="max-w-[1015px] font-['Source_Sans_Pro','Open_Sans',Arial,Helvetica,sans-serif] text-[13px] font-medium leading-[22px] text-white/95 sm:text-[15px] sm:leading-[25px] lg:text-[17px] lg:leading-[28px]">
                    {banner.text}
                  </p>

                  <p className="max-w-[1015px] font-['Source_Sans_Pro','Open_Sans',Arial,Helvetica,sans-serif] text-[13px] font-medium leading-[22px] text-white/90 sm:text-[15px] sm:leading-[25px] lg:text-[17px] lg:leading-[28px]">
                    {banner.text2}
                  </p>

                  <p className="max-w-[1015px] font-['Source_Sans_Pro','Open_Sans',Arial,Helvetica,sans-serif] text-[13px] font-bold leading-[22px] text-white sm:text-[15px] sm:leading-[25px] lg:text-[17px] lg:leading-[28px]">
                    {banner.text3}
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => navigate("/products")}
                  className="mt-5 inline-flex cursor-pointer rounded-[12px] border-0 bg-gradient-to-b from-[#f97316] to-[#ea580c] px-6 py-3 font-['Montserrat',sans-serif] text-[13px] font-extrabold uppercase tracking-[0.5px] text-white shadow-[0_14px_32px_rgba(249,115,22,0.28)] outline-none transition-all duration-300 hover:-translate-y-0.5 hover:brightness-110 sm:text-[15px]"
                >
                  {banner.button}
                </button>
              </div>
            ) : (
              <div className="w-full">
                <h1 className="m-0 mb-3 block w-full font-['Source_Sans_Pro'] text-[26px] font-bold capitalize leading-[1.2] text-[#f97316] sm:text-[36px] lg:max-w-[1015px] lg:text-[48px] lg:leading-[57.6px]">
                  {banner.title}
                </h1>

                <p className="mb-5 mt-3 block w-full max-w-[1015px] font-['Source_Sans_Pro','Open_Sans',Arial,Helvetica,sans-serif] text-[14px] font-normal leading-[23px] text-white sm:text-[17px] sm:leading-[27px] lg:text-[20px] lg:leading-[30px]">
                  {banner.text}
                </p>

                <button
                  type="button"
                  onClick={() => navigate("/products")}
                  className="inline-block cursor-pointer rounded-[12px] border-0 bg-gradient-to-b from-[#f97316] to-[#ea580c] px-[18px] py-[9px] font-['Montserrat',sans-serif] text-[15px] font-bold uppercase leading-[25.5px] text-white outline-none transition-all duration-300 hover:brightness-110 sm:text-[17px]"
                >
                  {banner.button}
                </button>
              </div>
            )}
          </div>
        </div>

        <button
          type="button"
          onClick={prevBanner}
          className="group absolute left-2 top-1/2 z-30 flex h-[42px] w-[42px] -translate-y-1/2 cursor-pointer items-center justify-center border-0 bg-transparent p-0 sm:left-5 sm:h-[50px] sm:w-[50px] lg:left-[48px] lg:h-[56px] lg:w-[56px]"
          aria-label="Previous"
        >
          <span className="block h-[20px] w-[20px] rotate-[135deg] border-b-[4px] border-r-[4px] border-white transition-all duration-300 group-hover:border-[#f97316] sm:h-[28px] sm:w-[28px] sm:border-b-[6px] sm:border-r-[6px]"></span>
        </button>

        <button
          type="button"
          onClick={nextBanner}
          className="group absolute right-2 top-1/2 z-30 flex h-[42px] w-[42px] -translate-y-1/2 cursor-pointer items-center justify-center border-0 bg-transparent p-0 sm:right-5 sm:h-[50px] sm:w-[50px] lg:right-[48px] lg:h-[56px] lg:w-[56px]"
          aria-label="Next"
        >
          <span className="block h-[20px] w-[20px] -rotate-45 border-b-[4px] border-r-[4px] border-white transition-all duration-300 group-hover:border-[#f97316] sm:h-[28px] sm:w-[28px] sm:border-b-[6px] sm:border-r-[6px]"></span>
        </button>
      </div>
    </>
  );
};

export default Hero;